$contact-list-item-font-size: $copy-small-font-size !default;
$contact-list-item-font-weight: $copy-small-font-weight !default;
$contact-list-item-line-height: $copy-small-line-height !default;

:host {
  display: block;
}
eon-ui-contact-list-item {
  eon-ui-link,
  p {
    display: block !important;
    --contentColor: var(--linkColor) !important;
    --contentHoverColor: var(--linkHoverColor) !important;
    --contentFocusColor: var(--linkHoverColor) !important;
    padding-bottom: 16px !important;
    font-size: $contact-list-item-font-size;
    font-weight: $contact-list-item-font-weight;
    line-height: $contact-list-item-line-height;

    @include for-size(tablet) {
      padding-bottom: 8px !important;
      padding-top: 8px !important;
      white-space: break-spaces;
      -moz-page-break-inside: avoid;
      -webkit-column-break-inside: avoid;
      break-inside: avoid;
      page-break-inside: avoid;
      display: flex !important;
    }
  }

  p {
    margin: 0 !important;
    color: var(--linkColor);
    padding-left: 10px !important;
  }
}
